const SIZE_MAPPER_API_URL = "https://size-mapper-api-998838505944.europe-west1.run.app/";

export async function getSizeMapperData(filename, version) {
    const sizeMapperURL = new URL(SIZE_MAPPER_API_URL);
    sizeMapperURL.searchParams.set("action", "load");
    sizeMapperURL.searchParams.set("filename", filename);
    sizeMapperURL.searchParams.set("version", version);

    const sizeMapperResponse = await fetch(sizeMapperURL).then(resp => resp.json());
    return sizeMapperResponse.data;
}

export async function saveSizeMapperData(filename, version, data) {
    await fetch(new URL(SIZE_MAPPER_API_URL), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'save', version, filename, data })
    });
}

export async function publishSizeMapperData(version, filename, target) {
    const response = await fetch(SIZE_MAPPER_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "publish",
            version: version,
            filename: filename.replace(".json", ""),
            target: target,
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to publish size mapper data: ${response.status}`);
    }
    
    return await response.json();
}
